import { createContext } from 'react';
import type { ViewportHeightRequest } from '../types/viewport-height-request.types';

/** Optional shell boundary for coordinating temporary keyboard replacement space. */
export const ViewportHeightContext = createContext<
  ViewportHeightRequest | undefined
>(undefined);
